import type { FactSetFirmHierarchy } from '../../../../../types/domain/firm/FactSetFirmHierarchy';

export const getFirmFromFactSetHierarchy = (
  selectedFactSetFirmId: string | null,
  hierarchy: FactSetFirmHierarchy | null
) =>
  hierarchy
    ? hierarchy.find(factSetFirm => factSetFirm.factSetFirmId === selectedFactSetFirmId) || null
    : null;
